import {
  IMPRESSIONS,
  OTS_SGM_MNG_ACTIVE_IDS,
  OTS_SGM_MNG_CPM,
  OTS_SGM_MNG_EFFECTIVE_CPM,
  OTS_SGM_MNG_LAST_UPDATED,
  OTS_SGM_MNG_POM,
  OTS_SGM_MNG_RECEIVED_IDS,
  OTS_SGM_MNG_REVENUE,
} from '../../content';
import {
  OTS_SEGMENT_MANAGER_COLUMN_KEYS,
  OTS_SEGMENT_MANAGER_DEFAULT_PLATFORM,
} from '../../constants';

export const PLATFORM_OPTIONS = [
  {
    label: OTS_SEGMENT_MANAGER_DEFAULT_PLATFORM,
    value: OTS_SEGMENT_MANAGER_DEFAULT_PLATFORM,
  },
];

/**
 * TTD platform column configuration
 */
export const TTD_COLUMNS = [
  {
    title: OTS_SGM_MNG_RECEIVED_IDS,
    column: OTS_SEGMENT_MANAGER_COLUMN_KEYS.RECEIVED_IDS,
    width: '11%',
    rightAlign: true,
    isSortDisabled: true,
  },
  {
    title: OTS_SGM_MNG_ACTIVE_IDS,
    column: OTS_SEGMENT_MANAGER_COLUMN_KEYS.ACTIVE_IDS,
    width: '11%',
    rightAlign: true,
    isSortDisabled: true,
  },
  {
    title: OTS_SGM_MNG_CPM,
    column: OTS_SEGMENT_MANAGER_COLUMN_KEYS.CPM,
    width: '9%',
    rightAlign: true,
    isSortDisabled: true,
  },
  {
    title: OTS_SGM_MNG_POM,
    column: OTS_SEGMENT_MANAGER_COLUMN_KEYS.POM,
    width: '7%',
    rightAlign: true,
    isSortDisabled: true,
  },
  {
    title: IMPRESSIONS,
    column: OTS_SEGMENT_MANAGER_COLUMN_KEYS.IMPRESSIONS,
    width: '11%',
    rightAlign: true,
    isSortDisabled: true,
  },
  {
    title: OTS_SGM_MNG_EFFECTIVE_CPM,
    column: OTS_SEGMENT_MANAGER_COLUMN_KEYS.EFFECTIVE_CPM,
    width: '11%',
    rightAlign: true,
    isSortDisabled: true,
  },
  {
    title: OTS_SGM_MNG_REVENUE,
    column: OTS_SEGMENT_MANAGER_COLUMN_KEYS.REVENUE,
    width: '11%',
    rightAlign: true,
    isSortDisabled: true,
  },
  {
    title: OTS_SGM_MNG_LAST_UPDATED,
    column: OTS_SEGMENT_MANAGER_COLUMN_KEYS.LAST_UPDATED_AT,
    width: '11%',
    isSortDisabled: true,
    rightAlign: true,
  },
];
